module.exports = __webpack_public_path__ + "static/media/flask-lab-medical-svgrepo-com.bb84481c.svg";